import axios from 'axios'
import { Notification, MessageBox } from 'element-ui'
import store from '@/store'
import { getToken, getUser, removeToken, removeUser} from '@/utils/auth'
import Config from '@/config'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production1' ? process.env.BASE_API : '', // api 的 base_url
  timeout: Config.timeout // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    NProgress.start()
    //NProgress.set(0.6)
    if (getToken()) {
      config.headers['AuthorizationToken'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers['AuthorizationUser'] = getUser()// 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    NProgress.done()
    const code = response.status
    if (code < 200 || code > 300) {
      Notification.error({
        title: response.message,
        duration: 1500
      })
      return Promise.reject('error')
    } else {
      return response
    }    
  },
  error => {
    NProgress.done()
    let code = 0
    try {
      code = error.response.status
    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        Notification.error({
          title: '网络请求超时',
          duration: 1500
        })
        return Promise.reject(error)
      }
      if (error.toString().indexOf('Error: Network Error') !== -1) {
        Notification.error({
          title: '网络请求错误',
          duration: 1500
        })
        return Promise.reject(error)
      }
    }    
    if (code === 404) {
      Notification.error({
        title: '导出数据超出最大值100万行',
        duration: 1500
      })
        
    } else if (code === 405) {
      Notification.error({
        title: '导出数据超出当前系统设置的最大值，若要继续操作请在系统设置中修改参数配置',
        duration: 1500
      })
    } else {
      const errorMsg = error.response.data.message
      if (errorMsg !== undefined) {
        Notification.error({
          title: errorMsg,
          duration: 1500
        })
      }else{
        Notification.error({
          title: '请求异常',
          duration: 1500
        })
      }
    }
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/requestStream.js